<template>
  <CompanyWrapper>
    <CommonQuestion></CommonQuestion>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/sp/company/CompanyWrapper";
import CommonQuestion from "../../../../components/sp/faq/CommonQuestion";
export default {
  components: {
    CompanyWrapper,
    CommonQuestion,
  },
  name: "Question",
};
</script>



// WEBPACK FOOTER //
// src/pages/sp/company/faq/Question.vue